import classNames from 'clsx';
import React, { memo, useEffect } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { Kind } from 'reactApp/types/Tree';
import { FileIcon } from 'reactApp/ui/FileIcon/FileIcon';
import { getIconType } from 'reactApp/ui/FileIcon/getIconType';
import { NameComponent } from 'reactApp/ui/Name/Name';
import { noop } from 'reactApp/utils/helpers';

import { IViewerDwhData } from '../ReactViewer.helpers';
import styles from './Stub.css';

interface Props {
    ext?: string;
    kind: Kind;
    isVirus: boolean;
    name?: string;
    onClick?(): void;
    showName?: boolean;
    mode?: 'light' | 'dark';
    size?: 'small' | 'medium' | 'big';
    sendRadar?: (data: IViewerDwhData) => void;
}

export const Stub = memo(function Stub({
    ext,
    kind,
    isVirus,
    name,
    onClick = noop,
    showName = true,
    mode = 'light',
    size = 'medium',
    sendRadar,
}: Props): JSX.Element | null {
    const iconType = getIconType({ isFolder: false, ext, kind, isVirus });

    useEffect(() => {
        sendRadar?.({ action: 'open-content-preview-error', forceSend: true });
    }, []);

    return (
        <div className={classNames({ [styles.root]: true, [styles[`root_${size}`]]: true })} onClick={() => onClick()}>
            <div className={styles.content}>
                <FileIcon type={iconType} view={EViewMode.thumbs} mode={mode} />
            </div>
            {showName && name && (
                <div className={styles.footer}>
                    <div className={styles.meta}>
                        <div className={styles.name}>
                            <NameComponent name={name} extension={ext} showTooltip />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
});
